
export default {
  name: 'DashboardMemoItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentUserId() {
      return this.$store?.state?.user?.profile?._id || '';
    },
    isMemoAdmin() {
      return !!this.$store?.state?.user?.role?.isAdmin;
    },
    canDelete() {
      const isCreator =
        !!this.item?.userId &&
        !!this.currentUserId &&
        this.item.userId === this.currentUserId;

      return isCreator || this.isMemoAdmin;
    },
    formattedMeta() {
      const locale = (
        this.$store?.getters?.['user/getLocale'] || 'en'
      ).toLowerCase();
      const authorName = this.item?.authorName || 'User';
      const startDate = this.item?.startDate;
      const startHour = this.item?.startHour;

      if (!startDate || startHour === undefined || startHour === null) {
        return this.item?.meta || authorName;
      }

      const dateString = startDate.toString();
      const formattedDate = `${dateString.slice(0, 4)}/${dateString.slice(
        4,
        6
      )}/${dateString.slice(6, 8)}`;
      const jaDate = `${dateString.slice(0, 4)}\u5e74${dateString.slice(
        4,
        6
      )}\u6708${dateString.slice(6, 8)}\u65e5`;
      const hour = String(Math.floor(startHour / 100)).padStart(2, '0');
      const minute = String(startHour % 100).padStart(2, '0');
      const jaTime = `${hour}\u6642${minute}\u5206`;

      return locale.includes('ja')
        ? `${authorName}, ${jaDate} ${jaTime}`
        : `${authorName}, ${formattedDate} at ${hour}:${minute}`;
    }
  }
};
